import React, {useEffect, useState} from "react";
import useStore from "../store";
import AlertContent from "./AlertContent";


function HudAlerts() {
    const [hint, setHint] = useState(false);
    const dice = useStore(state => state.dice);
    const locatorDisable = useStore(state => state.locatorDisable);

    useEffect(() => {
            if (dice > 0 || dice < 0) {
                setHint(true)
                const timer = setTimeout(() => {
                    setHint(false)
                    locatorDisable();
                }, 5000);
                return () => clearTimeout(timer);
            }
        }, []
    )


    if (hint) {
        return (
            <AlertContent/>
        )
    } else return null
}

export default HudAlerts;
